export const fetchPresignedUrl = async (
  paths,
  token,
  couchbaseCache = false
) => {
  if (Array.isArray(paths)) {
    const urls = [];
    for (let i = 0; i < paths.length; i++) {
      let presigned = await getURL(paths[i], token, couchbaseCache);
      urls.push(presigned);
    }
    return urls;
  } else if (typeof paths === 'string') {
    return getURL(paths, token, couchbaseCache);
  }
};
async function getURL(path, token, couchbaseCache) {
  let url = `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticketphoto?filename=${path}&urlType=get`;

  let pdfCheck = path.substr(path.lastIndexOf('.') + 1);

  if (couchbaseCache === true) {
    url = `${url}&bucket=${process.env.REACT_APP_S3_CACHE_BUCKET}`;
  }
  if (pdfCheck === 'pdf') {
    url = `${url}&bucket=${process.env.REACT_APP_S3_ACE_BUCKET}`;
  }

  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });
  const encodedURL = encodeURI(url);

  const response = await fetch(encodedURL, {
    method: 'GET',
    headers,
  });
  return await response.text();
}
